'use client';

import { create } from 'zustand';

export type CreatorReferralsModalMode = 'redeem' | 'share';
export type CreatorReferralsSource = 'header' | 'low_credits' | 'credits_exhausted' | 'manual';
export interface CreatorReferralsModalOptions {
  source?: CreatorReferralsSource;
}

interface CreatorReferralsModalStore {
  isOpen: boolean;
  mode: CreatorReferralsModalMode;
  source: CreatorReferralsSource;
  openCreatorReferralsModal: (mode?: CreatorReferralsModalMode, options?: CreatorReferralsModalOptions) => void;
  closeCreatorReferralsModal: () => void;
}

let creatorReferralsModalRuntimePromise: Promise<void> | null = null;

function ensureCreatorReferralsModalRuntime(): void {
  if (typeof window === 'undefined') return;
  creatorReferralsModalRuntimePromise ??= import('@/components/referrals/CreatorReferralsModalRuntime')
    .then((module) => {
      return module.mountCreatorReferralsModalRuntime();
    })
    .catch((error) => {
      creatorReferralsModalRuntimePromise = null;
      console.error('[CreatorReferralsModal] Failed to load runtime', error);
    });
}

export const useCreatorReferralsModalStore = create<CreatorReferralsModalStore>((set) => ({
  isOpen: false,
  mode: 'share',
  source: 'manual',

  openCreatorReferralsModal: (mode = 'share', options = {}) => {
    ensureCreatorReferralsModalRuntime();
    set({ isOpen: true, mode, source: options.source ?? 'manual' });
  },

  closeCreatorReferralsModal: () => {
    set({ isOpen: false });
  },
}));

export const creatorReferralsModal = {
  open: (mode: CreatorReferralsModalMode = 'share', options?: CreatorReferralsModalOptions) => {
    useCreatorReferralsModalStore.getState().openCreatorReferralsModal(mode, options);
  },
  close: () => {
    useCreatorReferralsModalStore.getState().closeCreatorReferralsModal();
  },
};
